import { useRef } from 'react';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';

import { persistor, store } from 'app/store';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

const GlobalStoreProvider: FunctionComponent<Props> = ({ children, testId = TEST_ID }) => {
    const storeMap = useRef({
        reduxToolkit: () => (
            <Provider store={store}>
                <PersistGate loading={null} persistor={persistor}>
                    {children}
                </PersistGate>
            </Provider>
        )
    }).current;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const StoreProvider = storeMap.reduxToolkit as any;

    return <StoreProvider data-testid={testId}>{children}</StoreProvider>;
};

export default GlobalStoreProvider;
